import { faDiamondExclamation, faInfo } from '@fortawesome/pro-light-svg-icons';
import { faCheck, faRemove } from '@fortawesome/pro-regular-svg-icons';
import { AlertProps } from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { colors } from '../../themes/colors';
import Icon from '../Icon';

export default function ModuleErrorBar(props: ModuleErrorBarProps): React.JSX.Element {
    const { errorMessage, type = 'info', onClose } = props;

    return (
        <Box
            px={{ xs: 0 }}
            sx={{
                backgroundColor: type === 'success' ? colors.successLight : `${type}.light`,
                minHeight: '48px',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
            }}
        >
            <Box
                sx={{
                    flexShrink: 0,
                    width: '48px',
                    backgroundColor: `${type}.main`,
                    color: 'white',
                    display: 'flex',
                    flexDirection: 'column',
                    alignContent: 'center',
                    justifyContent: 'center',
                    alignSelf: 'stretch', // fill the full height of the bar
                }}
            >
                <Icon
                    icon={
                        type === 'info'
                            ? faInfo
                            : type === 'success'
                              ? faCheck
                              : faDiamondExclamation
                    }
                    data-testid="test-id-icon"
                    widthAuto // Required to center the icon
                />
            </Box>
            <Box pl={2} py={1} sx={{ flex: 1 }}>
                <Typography className="error-message" variant="body1">
                    {errorMessage}
                </Typography>
            </Box>
            {onClose && (
                <IconButton
                    onClick={onClose}
                    data-testid="module-error-bar-close"
                    size="small"
                    sx={{
                        mr: 1,
                        color:
                            type === 'success'
                                ? colors.success
                                : type === 'info'
                                  ? colors.info
                                  : type === 'warning'
                                    ? colors.warning
                                    : colors.error,
                    }}
                >
                    <Icon icon={faRemove} />
                </IconButton>
            )}
        </Box>
    );
}

export type ModuleErrorBarProps = {
    errorMessage: string;
    type?: AlertProps['severity'];
    onClose?: () => void;
};
